import React from "react";
import PropTypes from "prop-types";
import { FormGroup, TextField } from "@material-ui/core";

const InputFiled = (props) => {
  const { field, form, type, label, placeholder, disable, multiline } = props;
  const { name, value, onChange, onBlur } = field;
  const { errors, touched } = form;

  const showError = errors[name] && touched[name];

  return (
    <FormGroup>
      <TextField
        label={label}
        placeholder={placeholder}
        id={name}
        {...field}
        type={type}
        disabled={disable}
        multiline={multiline}
        helperText={showError ? errors[name] : ""}
        error={showError ? true : false}
      />
    </FormGroup>
  );
};

InputFiled.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,

  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disable: PropTypes.bool,
};

InputFiled.defaultProps = {
  type: "text",
  label: "",
  placeholder: "",
  disable: false,
};

export default InputFiled;
